<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'generic.create-new-contest' | translate}}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<div class="container">
  <mat-card class="w-75 my-5 ml-auto mr-auto">
    <mat-card-content>
      <form (ngSubmit)="onSubmit()">
        <mat-form-field class="full-width">
          <mat-label>Titolo</mat-label>
          <input matInput [(ngModel)]="dataModel.title" name="title" required>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Descrizione</mat-label>
          <textarea matInput [(ngModel)]="dataModel.description" name="description" rows="5" required></textarea>
        </mat-form-field>
        <div class="row justify-content-center my-3">
          <button mat-stroked-button class="text-dark-purple border-purple mr-2" (click)="closeDialogue()" [disabled]="loading">{{"generic.buttons.cancel-and-back" | translate}}</button>
          <button mat-raised-button color="primary" [disabled]="loading" type="submit">{{"generic.send" | translate}}</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
